import {Component, OnInit} from '@angular/core';
import {NgxSpinnerService} from "ngx-spinner";
import {Router} from "@angular/router";
import {Assignment} from "../../models/assignment/assignment";
import {AssignmentService} from "../../services/assignment.service";
import {SweetAlertService} from "../../services/sweet-alert.service";

@Component({
  selector: 'app-external-active-assignment',
  templateUrl: './external-active-assignment.component.html',
  styleUrls: ['./external-active-assignment.component.scss']
})
export class ExternalActiveAssignmentComponent implements OnInit {
  assignments: Assignment[] = [];
  currentPage: number = 1;
  totalItems: number = 25;
  disabled: boolean = false;
  sortColumn: string = 'ProjectName';
  configTableMaxRow: number = 10;

  constructor(
    private spinner: NgxSpinnerService,
    private assignmentService:AssignmentService,
    private router: Router,
    private sweetAlertService: SweetAlertService
  ) {

  }

  ngOnInit(): void {
    this.loadApplicationList();
  }

  pageChanged(event: any): void {
    console.log('Page changed to: ' + event.page);
    this.loadApplicationList(event.page);
  }

  sort(column: string) {
    console.log('sorted');
    this.sortColumn = column;
    this.currentPage = 1;
    this.loadApplicationList(this.currentPage);
  }

  loadApplicationList(page: number = 1) {
    this.spinner.show();
    this.assignmentService.getAssignmentList(page, this.configTableMaxRow, this.sortColumn).subscribe(
      async data => {
        await this.spinner.hide();

        if (!data.result) {

          await this.sweetAlertService.error(
            'Error',
            data.messages?.join(' ') || 'An unexpected error occurred. Please try again.'
          );
        } else {
          this.assignments = data.item?.items ?? [];
          this.totalItems = data.item?.total ?? 0;
          this.currentPage = page;
        }
      },
      async error => {
        await this.spinner.hide();
        console.error('Error fetching assignment:', error);

      }
    );
  }

  navigateToDetails(assignment: Assignment) {

    const appid = assignment.id;

     this.router.navigate(['external-active-assignment', appid]);

  }

  getStatusName(assignment: Assignment) {
    if (assignment.statusName === "AwaitingSignatures") {
      return "Awaiting Signatures";
    }else {
      return assignment.statusName;
    }
  }
}
